import { Button, cn } from "@tellescope/ui";
import { ComponentProps, ReactNode, Ref } from "react";

export interface MarkButtonProps {
  /** Accessible label (the visible content is the icon). */
  label: string;
  icon: ReactNode;
  isActive: boolean;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  /**
   * Forwarded to the underlying button. Present so a Radix `asChild` trigger/anchor (e.g. a Popover)
   * can attach its ref for positioning; unused for a plain toolbar button.
   */
  ref?: Ref<HTMLButtonElement>;
  /** Extra button props forwarded verbatim — lets an `asChild` parent inject its handlers/attrs. */
  buttonProps?: ComponentProps<typeof Button>;
}

/** An icon toolbar toggle button reflecting an active formatting mark. */
export const MarkButton = ({
  label,
  icon,
  isActive,
  onClick,
  className,
  disabled,
  ref,
  buttonProps,
}: MarkButtonProps) => (
  <Button
    type="button"
    size="sm"
    variant={isActive ? "secondary" : "ghost"}
    aria-label={label}
    aria-pressed={isActive}
    title={label}
    disabled={disabled}
    className={cn("h-8 w-8 p-0", className)}
    onClick={onClick}
    ref={ref}
    {...buttonProps}
  >
    {icon}
  </Button>
);
